import { useQuery } from '@tanstack/react-query';
import { getInvoicesCountPendingValidation } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoicesCountPendingValidation() {
    const { data: invoicesCount = 0, isLoading } = useQuery({
        queryKey: ['invoices', 'count', 'pending-validation'],
        queryFn: getInvoicesCountPendingValidation,
        onError: (error) => trackError(error),
    });

    return {
        invoicesCount,
        isLoading,
    };
}
